export default __webpack_public_path__ + "static/shapewire-0769150a161d14972b23a8a6126ead2e.png";